// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"6eddfac8","143":"8d035c5f","155":"9009726a","352":"a1231256","488":"57280a5b","493":"4d076adc","747":"e4d40ff6","905":"2c9f6edd","927":"876eb0a1"}[chunkId] + ".chunk.js";
};